/**
 * @fileoverview DELETE handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_components/:component/variants/:variant_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdCacheKeys } from "./constants";
import type {
  DeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdProps,
  DeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult,
} from "./types";

export const deleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantId =
  reactQueryMutationAdapter(
    deleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdCacheKeys,
    (
      props: DeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdProps
    ): Promise<DeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult> => {
      return fetch(
        `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/creative_components/${props.component}/variants/${props.variant_id}`,
        "DELETE",
        { write_mode: props.write_mode },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  );
